import { render, staticRenderFns } from "./index-v3.vue?vue&type=template&id=b7ffd4d4&scoped=true&"
import script from "./index-v3.vue?vue&type=script&lang=js&"
export * from "./index-v3.vue?vue&type=script&lang=js&"
import style0 from "./index-v3.vue?vue&type=style&index=0&lang=css&"
import style1 from "./index-v3.vue?vue&type=style&index=1&id=b7ffd4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ffd4d4",
  null
  
)

export default component.exports